import GlobalNavigationHeader from './GlobalNavigationHeader'
export default GlobalNavigationHeader